<mat-radio-group [ngClass]="(positionField === field && onBuilder)  ? 'active-control' : ''" [(ngModel)]="value" (change)="radiobuttonValidator($event)">
    <mat-radio-button [value]="option" *ngFor="let option of options">{{option}}</mat-radio-button> 
</mat-radio-group>